/** Префикс временного id до ответа сервера (direct messages). */
export const MESSENGER_OPTIMISTIC_ID_PREFIX = 'opt/';

export function isMessengerOptimisticMessageId(id: string): boolean {
  return id.startsWith(MESSENGER_OPTIMISTIC_ID_PREFIX);
}
